import React from 'react';
import { connect } from 'react-redux';

// Popup imports
class FailedLoad extends React.Component {
    render = () => {
        const { popup } = this.props;

        return (
            <div>
                <h1>
                    Oeps!
                </h1>
                <p>
                    Er ging iets mis tijdens het laden.<br/>Probeer het later opnieuw.
                </p>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    popup: state.popup
});

export default connect(
    mapStateToProps
)(FailedLoad);